<template>
 <section class="section mobile_div section_bg first_page">
    <div class="container-flud mobile_div ">

      <div   v-if="is_load_invoice">
        <div class="section_header mobile_div back_div_element"  >
          <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>

        <div class="section_header mobile_div" v-if="is_load_invoice">
          <h2 class="ml-2 mt-3 mb-3" v-if="is_load_invoice">Мои счета</h2>
        </div>
      </div>


      <loading-block v-if="is_load_invoice==false" :loading="!is_load_invoice"/>
      <div class="col-md-12 center-block loading_div " v-if="is_load_invoice==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div class=" mobile_div center-block" v-if="is_load_invoice">

        <div v-if="available && available.length>0" class="section_header pt-2 pb-2 mt-2 mb-2">
          <h4 class="m-2 text-center">Доступно к выводу:</h4>
          <p class="m-2 text-center"  v-for="(current_available,available_index) in available" :key="available_index">{{ current_available.sum}} {{ current_available.currency}}</p>

          <p class="m-2 text-center">  <router-link :to="{name: 'withdrawal'}"
              class="btn">
          Вывести
          </router-link></p>
        </div>


          <div class="section_header mobile_div" v-if="status_form_filter==false">
            <p ><button @click="toogleFormFilter" class="btn">показать <i class="fa fa-filter"></i></button></p>
          </div>
        <div class="section_header mobile_div" v-if="status_form_filter==true">
          <p v-if="status_form_filter==true"><button  @click="toogleFormFilter" class="btn">скрыть <i class="fa fa-filter"></i></button></p>
        </div>

        <div class="section_header pt-2 pb-2 mt-2 mb-2" v-if="status_form_filter==true">
          <h4 class="m-2 text-center">Фильтр</h4>
          <div class="row" v-if="conf.ismarketplace">
            <div class="col-12 col-md-6">
              <label for="exampleUser">Статус заказа </label>
            </div>
            <div class="col-12 col-md-6">   <select id="exampleUser"   required v-model="filter.status_id"
                class="form-control">
              <option value="none">не указан</option>
              <option v-if="data_form.statuses.length>0"
                  v-for="(status,status_index) in data_form.statuses" :value="status.last_id" :key="status.last_id">
                {{ status.title }}
              </option>


            </select></div>



          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <label for="exampleUser">Статус оплаты </label>
            </div>
            <div class="col-12 col-md-6" :class="{'col-md-6 col-12':!conf.ismarketplace,'col-md-12 col-12':!conf.ismarketplace}">

              <select id="exampleUser"   required v-model="filter.ispay"
                  class="form-control">
                <option value="none">не указан</option>
                <option value="no">не оплачен</option>
                <option value="yes">оплачен</option>


              </select>


            </div>

          </div>
          <div class="row" v-if="conf.isservice">
            <div class="col-md-6 col-12">
              <label for="exampleUser">Тип оплаты </label>
            </div>
            <div class=" col-md-6 col-12">

              <select id="exampleUser"   required v-model="filter.type_pay"
                  class="form-control">
                <option value="none">не указан</option>
                <option value="one">разовая</option>
                <option value="every_month">каждый месяц</option>
                <option value="every_month">каждый год</option>

              </select>


            </div>
          </div>
          <div class="row " v-if="conf.isservice">
         <div class="col-md-6 col-12">
           <label for="exampleUser">Услуга </label>
         </div>
            <div class="form-group col-md-6 col-12">

              <select id="exampleUser"   required v-model="filter.service_id"
                  class="form-control">
                <option value="none">не указан</option>
                <option v-if="data_form.services.length>0"
                    v-for="(service,service_index) in data_form.services" :value="service.last_id" :key="service.last_id">
                    {{ service.name}}
                </option>



              </select>


            </div>

          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <button class="btn btn-second" @click="searchByFilter">Найти</button>
            </div>
          </div>
        </div>
        <div class="section_header mobile_div pt-2 pb-2 mt-2 mb-2"
            v-if="invoices.length>0"
            v-for="(invoice,invoice_index) in invoices" :key="invoice.invoice_id">
          <div class="row m-4 " v-if="invoice.client_id==user.last_id">
            <div class="col-lg-3">
              <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                           class="mb-3 btn">
                {{ invoice.last_id }}
              </router-link>
              <br>
              <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                  class="mb-3  mt-2 btn">
                открыть
              </router-link>
            </div>
            <div class="col-lg-2">
              <p>{{ invoice.created_at}}</p>
            </div>

            <div class="col-lg-4">
              <div v-if="!(invoice.order && invoice.order.status)">
              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 " pill type="danger">Необходимо оплатить
              </badge>
                <badge v-if="invoice.ispay==1 && invoice.is_complete==0" pill type="danger">Ожидает подтверждения
                </badge>
              <badge v-if="invoice.client_pay==1 && invoice.ispay==0" pill type="danger">Ожидаем<br>подтверждение
              </badge>
              <badge v-if="invoice.ispay==1 && !invoice.order" pill type="success">Счет оплачен</badge>
              <badge v-if="invoice.ispay==1 && invoice.order && invoice.order.status && invoice.order.status.title" >{{ invoice.order.status.title}} </badge>
              </div>
              <div v-if="(invoice.order && invoice.order.status)">
                <badge   pill type="warning">{{ invoice.order.status.title }}</badge>
                <badge v-if="invoice.client_pay==0 && invoice.ispay==0 && invoice.order.status.is_wait==0 " pill type="danger">Необходимо оплатить
                </badge>
                <badge v-if="invoice.ispay==1" pill type="success">Счет оплачен</badge>
              </div>
              <div v-if="(invoice.type && (invoice.type=='every_month' || invoice.type=='every_year'))">
                <badge   pill type="info" v-if="invoice.type=='every_month'">каждый месяц</badge>
                <badge   pill type="info" v-if="invoice.type=='every_year'">каждый месяц</badge>
              </div>

            </div>
            <div class="col-lg-3">


              <p>{{ invoice.sum }} <i>{{ invoice.currency}}</i></p>
            </div>
          </div>

          <div class="row m-4" v-if="invoice.developer_id==user.last_id">
            <div class="col-lg-3">
              <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                           class="mb-3  btn">
                #{{
                  invoice.last_id
                }}
              </router-link>
              <br>
              <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                  class="mb-3 mt-2 ml-1 mb-sm-0 btn">
                открыть
              </router-link>
            </div>
            <div class="col-lg-2">
              <p>{{ invoice.created_at}}</p>
            </div>

            <div class="col-lg-4">

              <div v-if="!(invoice.order && invoice.order.status)">


              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 " pill type="info">Ждем денег</badge>
              <badge v-if="invoice.client_pay==1 && invoice.ispay==0" pill type="primary">Клиент отправил денег
              </badge>
                <badge v-if="invoice.ispay==1 && invoice.is_complete==0" pill type="danger">Средства заморожены
                </badge>
              <badge v-if="invoice.ispay==1 && !invoice.order" pill type="success">Счет оплачен</badge>
              <badge v-if="invoice.ispay==1 &&invoice.order && invoice.order.status && invoice.order.status.title" >{{ invoice.order.status.title}} </badge>
              </div>
              <div v-if="(invoice.order && invoice.order.status && invoice.order.status.is_wait==0)">
                <badge   pill type="warning">{{ invoice.order.status.title }}</badge>
                <badge v-if="invoice.ispay==1" pill type="success">Счет оплачен</badge>
                <badge v-if="invoice.client_pay==0 && invoice.ispay==0 && invoice.order.status.is_wait==0" pill type="info">Ждем денег</badge>
              </div>
              <div v-if="(invoice.type && (invoice.type=='every_month' || invoice.type=='every_year'))">
                <badge   pill type="info" v-if="invoice.type=='every_month'">каждый месяц</badge>
                <badge   pill type="info" v-if="invoice.type=='every_year'">каждый месяц</badge>
              </div>
              <badge v-if="(invoice.order && invoice.order.status && invoice.order.status.is_wait==1)"   pill type="warning">ожидает вашего<br>подтверждения</badge>
            </div>
            <div class="col-lg-3">
              <p>{{ invoice.sum }} <i>{{ invoice.currency}}</i></p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-5 ml-1  " v-if="total>offset">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="loadMore()">Загрузить еще</button>

          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import {eventBus} from "@/main";
import OrderBlock from "@/components/Custom/OrderBlock";
import wysiwyg from "vue-wysiwyg";
import Modal from "@/components/Modal";
import axios from "axios";
import Vue from "vue";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";


export default {
  data() {
    return {
      "invoices_table": {
        "current_page": 1,
        "on_page": 10
      },
      'status_form_filter':false,
      'limit':20,
      'offset':0,
      'total':0,
      'is_load_chart': false,
      'circle_chart_rub_developer': {
        chartdata: {
          labels: ['Получено', 'Ждем денег',],
          datasets: [
            {
              label: '₽',
              backgroundColor: ['#03acca', '#ff3709'],
              data: [0, 0]
            },
            {
              label: '$',
              backgroundColor: ['#109D25', '#CA8D24',],
              data: [0, 0]
            },
            {
              label: '€',
              backgroundColor: ['#CA24C5', '#460569',],
              data: [0, 0]
            },

          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: 'Исполнитель'
          }
        }
      },
      'circle_chart_rub_client': {
        chartdata: {
          labels: ['Оплачено', 'Необходимо оплатить',],
          datasets: [
            {
              label: '₽',
              backgroundColor: ['#03acca', '#ff3709'],
              data: [0, 0]
            },
            {
              label: '$',
              backgroundColor: ['#109D25', '#CA8D24',],
              data: [0, 0]
            },
            {
              label: '€',
              backgroundColor: ['#CA24C5', '#460569',],
              data: [0, 0]
            },

          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: 'Клиент'
          }
        }
      },

      'available':[],
      'is_load_invoice': false,
      'user': {},
      'invoices': [],
      "type_currencys":[],
      "currencys_title":[],
      'filter':{
        "service_id":'none',
        "type_pay":'none',
        'ispay':'none',
        'status_id':'none'
      },
      'conf':{
        'isservices':false,
        'ismarketplace':false,
      },
      'data_form':{
        'statuses':[],
        'services':[]
      }
    }
  },
  mounted() {
    var app = this;



    Api.loadInvoices(app.limit,app.offset,app.filter,function(data){
      app.conf.ismarketplace=data.ismarketplace;
      app.conf.isservice=data.isservice;
      app.data_form.statuses=data.shop_statuses;
      app.data_form.services=data.services;
      app.is_load_invoice = true;
      app.available=data.available;
      app.user = data.user;
      app.invoices = data.invoices;
      app.total=data.total;
      app.offset=data.offset;


    });


  },
  methods:{
    toogleFormFilter(){
      var app=this;
      if(app.status_form_filter==true){
        app.status_form_filter=false;
      }else {
        app.status_form_filter=true;
      }

    },
    searchByFilter(){
     var app=this;
     app.offset=0;
     app.invoices=[];
     app.loadMore();
    },
    loadMore(){
      var app=this;

      Api.loadInvoices(app.limit,app.offset,app.filter,function(data){

        app.available=data.available;
        app.user = data.user;
        app.invoices = app.invoices.concat(data.invoices);
        app.total=data.total;
        app.offset=data.offset;


      });
    }
  },
  components: {LoadingBlock,OrderBlock}
}
</script>